import axiosInstance from "../../../interceptor/intercetptor-inctence";

export const suggestionsService = () => {
    return axiosInstance.post(`healthcare_providers/investigation/suggestion`, {
        pageNo : 1,
        pageSize: 10,
    });
}
